import animation from '@helpers/animation';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';

interface ButtonProps {
  theme: 'red' | 'white' | 'black' | 'lightgrey';
  iconTheme: 'red' | 'white' | 'black';
}

const baseSliderButtonStyles = css<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  transition: background-color 200ms ${animation.easeInOutCubic}, opacity 200ms ${animation.easeInOutCubic};
  position: relative;

  @media ${from(Device.TabletLarge)} {
    width: 48px;
    height: 48px;
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    width: 14px;
    height: 24px;
    margin-top: 3px;

    @media ${from(Device.TabletLarge)} {
      width: 17px;
      height: 29px;
    }
  }

  ${({ theme }) => {
    switch (theme) {
      case 'red': {
        return css`
          background-color: ${brand.red.base};
          color: ${brand.white};

          &:hover:not([disabled]) {
            background-color: ${brand.red.dark};
          }
        `;
      }

      case 'white': {
        return css`
          background-color: ${brand.white};
          color: ${brand.black};

          &:hover:not([disabled]) {
            background-color: ${brand.grey[80]};
          }
        `;
      }

      case 'black': {
        return css`
          background-color: ${brand.black};
          color: ${brand.white};

          &:hover:not([disabled]) {
            background-color: ${brand.grey[20]};
          }
        `;
      }

      case 'lightgrey': {
        return css`
          background-color: ${brand.grey[85]};
          color: ${brand.black};

          &:hover:not([disabled]) {
            background-color: ${brand.grey[75]};
          }
        `;
      }
    }
  }};

  ${({ iconTheme }) => {
    switch (iconTheme) {
      case 'red': {
        return css`
          svg {
            color: ${brand.red.base};
          }
        `;
      }

      case 'white': {
        return css`
          svg {
            color: ${brand.white};
          }
        `;
      }

      case 'black': {
        return css`
          svg {
            color: ${brand.black};
          }
        `;
      }
    }
  }};
`;

const SliderButtonElement = styled.button.attrs({ type: 'button' })`
  ${baseSliderButtonStyles};
`;

export const SliderButtonStyles = {
  SliderButtonElement,
};
